import { render, staticRenderFns } from "./MailRegistrationVerification.vue?vue&type=template&id=1c3595b5&scoped=true&"
import script from "./MailRegistrationVerification.vue?vue&type=script&lang=js&"
export * from "./MailRegistrationVerification.vue?vue&type=script&lang=js&"
import style0 from "./MailRegistrationVerification.vue?vue&type=style&index=0&id=1c3595b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3595b5",
  null
  
)

export default component.exports